'use client'

import cn from 'clsx'
import { Body, Button, Root } from '~/components/accordion'
import s from './faq.module.css'

import ChevronSVG from '~/public/svg/chevron.svg'

export function FaqItem({ data, className }) {
  return (
    <Root>
      {({ isOpen }) => {
        return (
          <div
            className={cn(
              className,
              s.faq__item,
              'relative dr-mt-10 dr-rounded-10 dt:dr-rounded-8 overflow-hidden'
            )}
          >
            <Button className="dr-py-14 dr-px-16 relative flex items-center justify-between w-full">
              <h4 className="dr-w-271 dt:w-full h6">{data?.title}</h4>
              <ChevronSVG
                className={cn('dr-w-10 transition-transform duration-300', {
                  'rotate-180': isOpen,
                })}
              />
            </Button>

            <Body className="relative">
              <p
                className="dr-px-16 dr-pb-14 p-s dr-pt-0 opacity-[0.56]"
                // biome-ignore lint/security/noDangerouslySetInnerHtml: <explanation>
                dangerouslySetInnerHTML={{ __html: data?.desc }}
              />
            </Body>
          </div>
        )
      }}
    </Root>
  )
}
